<div class="card">
  <div class="card-header">
    <span>{{ license.licenseType }}</span>
    <ia-tooltip [content]= "tooltipText" position="top" theme="primary">
    <span class="info-icon">
    </span>
  </ia-tooltip>
  </div>
  <div class="card-body">
    <span *ngIf="!isExpired()" class="status-dot"></span>
    <span *ngIf="isExpired()" class="inactive-dot"></span>
    <span>{{ getStatus() }}</span>
  </div>
  <div class="card-footer">
    <div class="card-footer valid" *ngIf="validFlag && !isExpiringSoon() && license.validUntilUtc">
      <img class="check-icon" [src]="getValidIconUrl()"/>
      <span translate="licenses.VALIID_TILL">{{ getFormattedDate(license.validUntilUtc) }}</span>
    </div>
    <div class="card-footer expired" *ngIf="!validFlag && license.validUntilUtc">
      <span class="alert-icon"></span>
      <span translate="licenses.EXPIRED">{{ getFormattedDate(license.validUntilUtc) }}</span>
    </div>
    <div class="card-footer expires-soon" *ngIf="validFlag && isExpiringSoon()">
      <span class="alert-medium-icon"></span>
      <span translate="licenses.EXPIRES">{{ getFormattedDate(license.validUntilUtc) }}</span>
    </div>
  </div>
</div>
